/* eslint-disable max-statements */
/* eslint-disable complexity */
/* eslint-disable max-lines */
import { useEffect } from "react"
import { Routers } from "../../../../../../../constant/Routers"
import { backToLogin } from "../../../../../../../utils/backToLogin"
import { InitialValues } from "../../../../constants/list/initialValues"
import {
  SchedulesListDataType,
  UseSchedulesListType,
} from "../../../../models/list"
import { setFormDataBasic } from "../../utils/getDataSubmit"
import { useVariables } from "../useVariables"
import { formatDateSaveDB } from "../../../../../../../utils/getDate"
import moment from "moment"
import { RangePickerProps } from "antd/lib/date-picker"
import { GeneralCode } from "../../../../../../../constant/GeneralCode"
import { convertSearchDataSubmit } from "../useApi/convertSearchDataSubmit"
import { TravelersDetailResType } from "../../../../../travelers/models/detail"
import { travelerApi } from "../../../../../travelers/apis"
import { AxiosErrorType } from "../../../../../../../infrastructure/axiosError/models"
import { pushStateError } from "../../../../../../../utils/pushStateError"

const { OTHER } = GeneralCode
const { SCHEDULES_BASIC_SEARCH_INITIAL_VALUES } = InitialValues
const { SCR210, SCR210_USER_SEARCH, SCR973 } = Routers

export const useSchedulesList =
  (): UseSchedulesListType<SchedulesListDataType> => {
    const {
      allCountries,
      arrivalCities,
      breadcrumbItems,
      columns,
      countries,
      dataSource,
      departments,
      dispatchType,
      dispatchTypeDetail,
      form,
      fullName,
      getArrivalCities,
      getData,
      getSchedules,
      goBack,
      goToAttention,
      goToSafety,
      goToSchedulesAdd,
      goToSchedulesConfirmDelete,
      goToSchedulesDetail,
      goToSchedulesEdit,
      handleCancelModalExport,
      handleExportFile,
      handleOpenModalExport,
      handleSearch,
      isAuthorities,
      isDisabledArrivalCity,
      isDisabledBtnCreateOrSend,
      isDisabledBtnDelete,
      isDisabledBtnRefer,
      isDisabledDispatchTypeDetail,
      isFromSCR114UserSearch,
      isGetCountries,
      isHiddenBtnCreateOrSendAttentions,
      isHiddenBtnCreateOrSendSafeties,
      isHiddenBtnDelete,
      isHiddenBtnEdit,
      isHiddenBtnExportCsv,
      isHiddenBtnExportExcel,
      isHiddenBtnExportExcelSafeties,
      isHiddenBtnExportExcelTravelers,
      isHiddenBtnRefer,
      isHiddenBtnResetForm,
      isHiddenBtnSearchBasic,
      isLoadingLayout,
      isLoadingTable,
      isOpenExportFrm103OverRecord,
      isOpenLoadData,
      isOpenModalExport,
      isOpenShowData,
      isPathnameAttentionsOrSafeties,
      isPathnameSchedules,
      isPathnameSchedulesOrTravelers,
      isPathnameTravelers,
      isResetTable,
      messageConfirmDownload,
      onBlurBasic,
      onCancelCustomLoadData,
      onCancelExportFrm103OverRecord,
      onChange,
      onChangeDispatchType,
      onChangeTable,
      onKeyDownBasic,
      onOkExportFrm103OverRecord,
      onOkLoadData,
      onOkShowData,
      overRecordLabel,
      pathname,
      perItem,
      purposeTravel,
      push,
      rowSelection,
      setIsDisabledArrivalCity,
      setIsDisabledDispatchTypeDetail,
      setSearchCondition,
      setTravelerId,
      state,
      userInformation,
    } = useVariables()

    const onChangeArrivalCountryCode = (value: string) => {
      getArrivalCities(value)
      form.setFieldsValue({ arrivalCity: "", arrivalCityCode: "" })
    }

    const onChangeArrivalCity = (value: string) => {
      setIsDisabledArrivalCity(value !== OTHER)
      form.setFieldValue("arrivalCity", "")
    }

    const onClickReset = () => {
      // eslint-disable-next-line no-undefined
      setSearchCondition(undefined)
      setIsDisabledDispatchTypeDetail(true)
      if (state?.isFromSCR115 && pathname !== SCR210) setTravelerId("")
      if (pathname === SCR210) {
        form.setFieldValue("fullName", fullName)
        document.getElementById("countryToTravel")?.focus()
        form.setFieldsValue({
          arrivalDateTimeDate: "",
          countryToTravel: "",
          departureDateTimeDate: "",
          departureFlightNumber: "",
          lodgingName: "",
          projectName: "",
          transitSearchType: "0",
          travelPurposeId: "",
        })
      } else {
        document.getElementById("fullName")?.focus()
        form.setFieldsValue({
          ...SCHEDULES_BASIC_SEARCH_INITIAL_VALUES,
        })
      }
    }

    const handleGetSchedules = () => {
      const _travelerId = state?.isFromSCR115
        ? state?.travelerId
        : isPathnameSchedules
        ? userInformation?.travelerId || ""
        : ""
      setTravelerId(_travelerId)
      const departureDateTime = isPathnameAttentionsOrSafeties ? moment() : null
      getSchedules({
        basic: {
          fullName: state?.fullName || "",
        },
        travelerId: _travelerId,
        trip: {
          departureDateTime: formatDateSaveDB(departureDateTime?.toString()),
        },
      })
    }

    const handleData = () => {
      if (state?.searchCondition) {
        const searchCondition = state?.searchCondition
        const values = setFormDataBasic(searchCondition)
        form.setFieldsValue(values)
        const _arrivalCountryCode = searchCondition.countryToTravel
        if (_arrivalCountryCode) {
          getArrivalCities(_arrivalCountryCode)
          setIsDisabledArrivalCity(values.arrivalCityCode !== OTHER)
        }
        const dataSearch = convertSearchDataSubmit({
          isPathnameAttentionsOrSafeties,
          isPathnameSchedules,
          pathname,
          searchCondition,
          userInformation,
          values,
        })
        getSchedules(dataSearch, true)
      } else {
        form.setFieldsValue({
          ...SCHEDULES_BASIC_SEARCH_INITIAL_VALUES,
        })
        form.setFieldValue("fullName", state?.fullName)
        if (isPathnameSchedules || state?.fullName || state?.travelerId) {
          handleGetSchedules()
        }
      }
      if (isPathnameSchedules && userInformation?.travelerId) {
        travelerApi
          .getTravelerDetails(userInformation.travelerId)
          .then(
            ({
              base: { dispatchTypeDetailName, dispatchTypeName },
            }: TravelersDetailResType) => {
              form.setFieldsValue({
                dispatchType: dispatchTypeName,
                dispatchTypeDetail: dispatchTypeDetailName,
                fullName,
              })
            },
          )
          .catch((error: AxiosErrorType) => {
            // 「SCR973_エラー情報の表示画面」に遷移する。
            const stateError = pushStateError(error)
            push({ pathname: SCR973, state: stateError })
          })
      }
      getData()
    }

    const disabledDateTo: RangePickerProps["disabledDate"] = (current) => {
      const departureDate = form?.getFieldValue("departureDateTimeDate")
      if (departureDate) {
        return (
          current &&
          current < moment(departureDate).add("days", -1).endOf("day")
        )
      }
      return false
    }

    useEffect(() => {
      // ユーザの画面アクセス許可チェックを処理する。
      if (isAuthorities) {
        // 「SCR973_エラー情報の表示画面」に遷
        const { pathname, state } = backToLogin()
        push({ pathname, state })
      } else if (pathname === SCR210_USER_SEARCH) {
        handleGetSchedules()
      } else handleData()
    }, [])

    return {
      arrivalCities,
      breadcrumbItems,
      columns,
      countries: isGetCountries ? countries : allCountries,
      dataSource,
      departments,
      disabledDateTo,
      dispatchType,
      dispatchTypeDetail,
      form,
      fullName,
      goBack,
      goToAttention,
      goToSafety,
      goToSchedulesAdd,
      goToSchedulesConfirmDelete,
      goToSchedulesDetail,
      goToSchedulesEdit,
      handleCancelModalExport,
      handleExportFile,
      handleOpenModalExport,
      handleSearch,
      isDisabledArrivalCity,
      isDisabledBtnCreateOrSend,
      isDisabledBtnDelete,
      isDisabledBtnRefer,
      isDisabledDispatchTypeDetail,
      isFromSCR114UserSearch,
      isHiddenBtnCreateOrSendAttentions,
      isHiddenBtnCreateOrSendSafeties,
      isHiddenBtnDelete,
      isHiddenBtnEdit,
      isHiddenBtnExportCsv,
      isHiddenBtnExportExcel,
      isHiddenBtnExportExcelSafeties,
      isHiddenBtnExportExcelTravelers,
      isHiddenBtnRefer,
      isHiddenBtnResetForm,
      isHiddenBtnSearchBasic,
      isLoading: isLoadingTable,
      isLoadingLayout,
      isOpenExportFrm103OverRecord,
      isOpenLoadData,
      isOpenModalExport,
      isOpenShowData,
      isPathnameSchedules,
      isPathnameSchedulesOrTravelers,
      isPathnameTravelers,
      isResetTable,
      messageConfirmDownload,
      onBlurBasic,
      onCancelCustomLoadData,
      onCancelExportFrm103OverRecord,
      onChange,
      onChangeArrivalCity,
      onChangeArrivalCountryCode,
      onChangeDispatchType,
      onChangeTable,
      onClickReset,
      onKeyDownBasic,
      onOkExportFrm103OverRecord,
      onOkLoadData,
      onOkShowData,
      overRecordLabel,
      perItem,
      purposeTravel,
      rowSelection,
    }
  }
